<template>
  <el-dialog id="inpatientEncoderDialog" :visible="show" :title="'Selected Code: ' + reviseToCode" width="90%" :before-close="handleClose">
    <div v-if="reviewSubset.disableDxPx">
      This review has not been started. Please start the review to edit codes via Code Books.
    </div>

    <template v-if="codeType === 'DX' && !reviewSubset.disableDxPx">
      <v-client-table id="dxGrid" class="hiaTable codeBooksCodeGrid" :data="reviewSubset.drgrecommendationsDx" :columns="dx.columns" :options="dx.options">
        <template slot="exclude" slot-scope="props">
          <div>
            <input type="checkbox" :checked="props.row.exclude" disabled>
          </div>
        </template>
        <template slot="recommendedDx" slot-scope="props">
          {{props.row.deleteCode ? 'DEL' : props.row.recommendedDx}}
        </template>
        <template slot="recDescCalc" slot-scope=" props">
          {{props.row.deleteCode ? 'Delete Code' : props.row.recDescCalc}}
        </template>
        <template slot="revise" slot-scope="props">
          <el-button :disabled="props.row.deleteCode || disabled" :title="props.row.deleteCode ? 'Delete code recommendation, revise on main record page' : null" @click="reviseDxCode(props.index - 1, reviseToCode)" type="text" size="small">Revise To {{reviseToCode}}</el-button>
        </template>
        <template slot="level2Revise" slot-scope="props">
          <el-button :disabled="disabled" @click="reviseDxCode(props.index - 1, reviseToCode, true)" type="text" size="small">Revise To {{reviseToCode}}</el-button>
        </template>
      </v-client-table>

      <span slot="footer" class="dialog-footer">
        <el-button-group style="float: right; margin: -15px 0px 0px 0px;">
          <el-button class="hiaButton" type="text" size="mini" @click="handleClose" plain round>Cancel</el-button>
          <el-button :disabled="disabled " v-if="!reviewSubset.disableDxPx" class="hiaButton" size="mini" @click="addDxCode(reviseToCode)" plain round>Add as Code Addition</el-button>
          <el-button :disabled="disabled" v-if="!reviewSubset.disableDxPx && reviewSubset.reviewLevel === 2" class="hiaButton" size="mini" @click="addDxCode(reviseToCode, true)" plain round>Add as Level 2 Code Addition</el-button>
        </el-button-group>
      </span>
    </template>

    <template v-if="codeType === 'PX' && !reviewSubset.disableDxPx">
      <v-client-table id="pxGrid" class="hiaTable codeBooksCodeGrid" :data="reviewSubset.drgrecommendationsPx" :columns="px.columns" :options="px.options">
        <template slot="exclude" slot-scope="props">
          <div>
            <input type="checkbox" :checked="props.row.exclude" disabled>
          </div>
        </template>
        <template slot="recommendedPx" slot-scope="props">
          {{props.row.deleteCode ? 'DEL' : props.row.recommendedPx}}
        </template>
        <template slot="recDescCalc" slot-scope=" props">
          {{props.row.deleteCode ? 'Delete Code' : props.row.recDescCalc}}
        </template>
        <template slot="revise" slot-scope="props">
          <el-button :disabled="props.row.deleteCode || disabled" :title="props.row.deleteCode ? 'Delete code recommendation, revise on main record page' : null" @click="revisePxCode(props.index - 1, reviseToCode)" type="text" size="small">Revise To {{reviseToCode}}</el-button>
        </template>
        <template slot="level2Revise" slot-scope="props">
          <el-button :disabled="disabled" @click="revisePxCode(props.index - 1, reviseToCode, true)" type="text" size="small">Revise To {{reviseToCode}}</el-button>
        </template>
      </v-client-table>

      <span slot="footer" class="dialog-footer">
        <el-button-group style="float: right; margin: -15px 0px 0px 0px;">
          <el-button class="hiaButton" type="text" size="mini" @click="handleClose" plain round>Cancel</el-button>
          <el-button :disabled="disabled" v-if="!reviewSubset.disableDxPx" class="hiaButton" size="mini" @click="addPxCode(reviseToCode)" plain round>Add as Code Addition</el-button>
          <el-button :disabled="disabled" v-if="!reviewSubset.disableDxPx && reviewSubset.reviewLevel === 2" class="hiaButton" size="mini" @click="addPxCode(reviseToCode, true)" plain round>Add as Level 2 Code Addition</el-button>
        </el-button-group>
      </span>
    </template>

    <template v-if="codeType === 'CPTAPC' && !reviewSubset.disableDxPx">
      <v-client-table id="cptGrid" class="hiaTable codeBooksCodeGrid" :data="reviewSubset.drgrecommendationsCPTs" :columns="cpt.columns" :options="cpt.options">
        <template slot="exclude" slot-scope="props">
          <div>
            <input type="checkbox" :checked="props.row.exclude" disabled>
          </div>
        </template>
        <template slot="revise" slot-scope="props">
          <el-button :disabled="disabled" @click="reviseCptCode(props.index - 1, reviseToCode)" type="text" size="small">Revise To {{reviseToCode}}</el-button>
        </template>
        <template slot="level2Revise" slot-scope="props">
          <el-button :disabled="disabled" @click="reviseCptCode(props.index - 1, reviseToCode, true)" type="text" size="small">Revise To {{reviseToCode}}</el-button>
        </template>
      </v-client-table>

      <span slot="footer" class="dialog-footer">
        <el-button-group style="float: right; margin: -15px 0px 0px 0px;">
          <el-button class="hiaButton" type="text" size="mini" @click="handleClose" plain round>Cancel</el-button>
          <el-button :disabled="disabled" v-if="!reviewSubset.disableDxPx" class="hiaButton" size="mini" @click="addCptCode(reviseToCode)" plain round>Add as Code Addition</el-button>
          <el-button :disabled="disabled" v-if="!reviewSubset.disableDxPx && reviewSubset.reviewLevel === 2" class="hiaButton" size="mini" @click="addCptCode(reviseToCode, true)" plain round>Add as Level 2 Code Addition</el-button>
        </el-button-group>
      </span>
    </template>

  </el-dialog>
</template>

<script>
  import HiaAuthorization from '@/mixins/hiaAuthorization'

  export default {
    name: 'InpatientReviewDialog',
    mixins: [HiaAuthorization],
    props: ['reviewSubset', 'reviseToCode', 'codeType', 'disabled'],
    data() {
      return {
        show: true,
        dx: {
          columns: ['lineSequence', 'exclude', 'originalDx', 'originalDescCalc', 'originalPoa', 'recommendedDx', 'recDescCalc', 'recommendedPoa', 'level2Dx', 'level2DescCalc', 'level2Poa', 'revise', 'level2Revise'],
          options: {
            hiddenColumns: this.reviewSubset.reviewLevel !== 2 ? ['level2Dx', 'level2DescCalc', 'level2Poa', 'level2Revise'] : [],
            sortable: [],
            filterable: false,
            orderBy: {
              column: 'lineSequence',
              ascending: true
            },
            headings: {
              lineSequence: function (h) {
                return 'Line'
              },
              exclude: function (h) {
                return 'Exclude'
              },
              originalDx: function (h) {
                return 'Original Dx'
              },
              originalDescCalc: function (h) {
                return 'Original Desc'
              },
              originalPoa: function (h) {
                return 'Original POA'
              },
              recommendedDx: function (h) {
                return 'Recommended Dx'
              },
              recDescCalc: function (h) {
                return 'Recommended Desc'
              },
              recommendedPoa: function (h) {
                return 'Recommended POA'
              },
              level2Dx: function (h) {
                return 'Level 2 Dx'
              },
              level2DescCalc: function (h) {
                return 'Level 2 Desc'
              },
              level2Poa: function (h) {
                return 'Level 2 POA'
              },
              revise: function (h) {
                return 'Revise'
              },
              level2Revise: function (h) {
                return 'Level 2 Revise'
              }
            },
            perPage: 50,
            sortIcon: { is: 'none' }
          }
        },
        px: {
          columns: ['lineSequence', 'exclude', 'originalPx', 'originalDescCalc', 'recommendedPx', 'recDescCalc', 'level2Px', 'level2DescCalc', 'revise', 'level2Revise'],
          options: {
            hiddenColumns: this.reviewSubset.reviewLevel !== 2 ? ['level2Px', 'level2DescCalc', 'level2Revise'] : [],
            sortable: [],
            filterable: false,
            orderBy: {
              column: 'lineSequence',
              ascending: true
            },
            headings: {
              lineSequence: function (h) {
                return 'Line'
              },
              exclude: function (h) {
                return 'Exclude'
              },
              originalPx: function (h) {
                return 'Original Px'
              },
              originalDescCalc: function (h) {
                return 'Original Desc'
              },
              recommendedPx: function (h) {
                return 'Recommended Px'
              },
              recDescCalc: function (h) {
                return 'Recommended Desc'
              },
              level2Px: function (h) {
                return 'Level 2 Px'
              },
              level2DescCalc: function (h) {
                return 'Level 2 Desc'
              },
              revise: function (h) {
                return 'Revise'
              },
              level2Revise: function (h) {
                return 'Level 2 Revise'
              }
            },
            perPage: 50,
            sortIcon: { is: 'none' }
          }
        },
        cpt: {
          columns: ['lineSequence', 'originalCpt', 'originalDescCalc', 'recommendedCpt', 'recDescCalc', 'level2Cpt', 'level2DescCalc', 'revise', 'level2Revise'],
          options: {
            hiddenColumns: this.reviewSubset.reviewLevel !== 2 ? ['level2Cpt', 'level2DescCalc', 'level2Revise'] : [],
            sortable: [],
            filterable: false,
            orderBy: {
              column: 'lineSequence',
              ascending: true
            },
            headings: {
              lineSequence: function (h) {
                return 'Line'
              },
              exclude: function (h) {
                return 'Exclude'
              },
              originalCpt: function (h) {
                return 'Original Cpt'
              },
              originalDescCalc: function (h) {
                return 'Original Desc'
              },
              recommendedCpt: function (h) {
                return 'Recommended Cpt'
              },
              recDescCalc: function (h) {
                return 'Recommended Desc'
              },
              level2Cpt: function (h) {
                return 'Level 2 Cpt'
              },
              level2DescCalc: function (h) {
                return 'Level 2 Desc'
              },
              revise: function (h) {
                return 'Revise'
              },
              level2Revise: function (h) {
                return 'Level 2 Revise'
              }
            },
            perPage: 50,
            sortIcon: { is: 'none' }
          }
        }
      }
    },
    mounted: function () {
      this.initialize()
    },
    methods: {
      initialize() {
      },
      handleClose() {
        this.$emit('close')
      },
      addDxCode(code, level2 = false) {
        const payload = {
          code: code,
          level2: level2
        }
        this.$emit('addDxCode', payload)
        this.$emit('close')
      },
      reviseDxCode(i, code, level2 = false) {
        const payload = {
          index: i,
          code: code,
          level2: level2
        }
        this.$emit('reviseDxCode', payload)
        this.$emit('close')
      },
      addPxCode(code, level2 = false) {
        const payload = {
          code: code,
          level2: level2
        }
        this.$emit('addPxCode', payload)
        this.$emit('close')
      },
      revisePxCode(i, code, level2 = false) {
        const payload = {
          index: i,
          code: code,
          level2: level2
        }
        this.$emit('revisePxCode', payload)
        this.$emit('close')
      },
      addCptCode(code, level2 = false) {
        const payload = {
          code: code,
          level2: level2
        }
        this.$emit('addCptCode', payload)
        this.$emit('close')
      },
      reviseCptCode(i, code, level2 = false) {
        const payload = {
          index: i,
          code: code,
          level2: level2
        }
        this.$emit('reviseCptCode', payload)
        this.$emit('close')
      }
    }
  }

</script>

<style>
.codeBooksCodeGrid .VuePagination__count {
  display: none;
}
</style>
